/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,uselessCode} checked by tsc
 */
import { NgModule } from '@angular/core';
import { DataPersistence } from './data-persistence';
/**
 * \@whatItDoes Provides services for enterprise Angular applications.
 *
 * See {\@link DataPersistence} for more information.
 */
import * as ɵngcc0 from '@angular/core';
export class NxModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return { ngModule: NxModule, providers: [DataPersistence] };
    }
}
NxModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NxModule });
NxModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NxModule_Factory(t) { return new (t || NxModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NxModule, [{
        type: NgModule,
        args: [{}]
    }], null, null); })();

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibngubW9kdWxlLmpzIiwic291cmNlcyI6WyJAbnJ3bC9ueC9zcmMvbngubW9kdWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxPQUFPLEVBQXVCLFFBQVEsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUM5RCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDckQ7QUFDRztBQUVIO0FBQ0E7QUFDQzs7QUFFRCxNQUFNLE9BQU8sUUFBUTtBQUNyQjtBQUFRO0FBQW1CO0FBQVEsSUFBakMsTUFBTSxDQUFDLE9BQU87QUFBSyxRQUNqQixPQUFPLEVBQUUsUUFBUSxFQUFFLFFBQVEsRUFBRSxTQUFTLEVBQUUsQ0FBQyxlQUFlLENBQUMsRUFBRSxDQUFDO0FBQ2hFLElBQUUsQ0FBQztBQUNIO29DQUxDLFFBQVEsU0FBQyxFQUFFOzs7OzswQkFDUDtBQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTW9kdWxlV2l0aFByb3ZpZGVycywgTmdNb2R1bGUgfSBmcm9tICdAYW5ndWxhci9jb3JlJztcbmltcG9ydCB7IERhdGFQZXJzaXN0ZW5jZSB9IGZyb20gJy4vZGF0YS1wZXJzaXN0ZW5jZSc7XG5cbi8qKlxuICogQHdoYXRJdERvZXMgUHJvdmlkZXMgc2VydmljZXMgZm9yIGVudGVycHJpc2UgQW5ndWxhciBhcHBsaWNhdGlvbnMuXG4gKlxuICogU2VlIHtAbGluayBEYXRhUGVyc2lzdGVuY2V9IGZvciBtb3JlIGluZm9ybWF0aW9uLlxuICovXG5ATmdNb2R1bGUoe30pXG5leHBvcnQgY2xhc3MgTnhNb2R1bGUge1xuICBzdGF0aWMgZm9yUm9vdCgpOiBNb2R1bGVXaXRoUHJvdmlkZXJzIHtcbiAgICByZXR1cm4geyBuZ01vZHVsZTogTnhNb2R1bGUsIHByb3ZpZGVyczogW0RhdGFQZXJzaXN0ZW5jZV0gfTtcbiAgfVxufVxuIl19